module.exports = __webpack_public_path__ + "static/media/greenFree3.67792346.jpg";